var isString = require('./string')
var isNumber = require('./number')

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @since 3.0.0
 * @category Lang
 * @memberOf is
 * @param {*} x The value to check.
 * @return {boolean} Returns `true` if `value` is a string, else `false`.
 *
 * @see https://github.com/infernojs/inferno/blob/master/packages/inferno-shared/src/index.ts#L23
 * @see https://github.com/lodash/lodash/blob/master/isString.js
 *
 * @example
 *
 * isString('abc')
 * // => true
 *
 * isString(1)
 * // => false
 */
module.exports = function (x) { return isString(x) || isNumber(x); }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nT3JOdW1iZXIuanMiLCJzb3VyY2VzIjpbInN0cmluZ09yTnVtYmVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGlzU3RyaW5nID0gcmVxdWlyZSgnLi9zdHJpbmcnKVxuY29uc3QgaXNOdW1iZXIgPSByZXF1aXJlKCcuL251bWJlcicpXG5cbi8qKlxuICogQ2hlY2tzIGlmIGB2YWx1ZWAgaXMgY2xhc3NpZmllZCBhcyBhIGBTdHJpbmdgIHByaW1pdGl2ZSBvciBvYmplY3QuXG4gKlxuICogQHNpbmNlIDMuMC4wXG4gKiBAY2F0ZWdvcnkgTGFuZ1xuICogQG1lbWJlck9mIGlzXG4gKiBAcGFyYW0geyp9IHggVGhlIHZhbHVlIHRvIGNoZWNrLlxuICogQHJldHVybiB7Ym9vbGVhbn0gUmV0dXJucyBgdHJ1ZWAgaWYgYHZhbHVlYCBpcyBhIHN0cmluZywgZWxzZSBgZmFsc2VgLlxuICpcbiAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL2luZmVybm9qcy9pbmZlcm5vL2Jsb2IvbWFzdGVyL3BhY2thZ2VzL2luZmVybm8tc2hhcmVkL3NyYy9pbmRleC50cyNMMjNcbiAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL2xvZGFzaC9sb2Rhc2gvYmxvYi9tYXN0ZXIvaXNTdHJpbmcuanNcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqIGlzU3RyaW5nKCdhYmMnKVxuICogLy8gPT4gdHJ1ZVxuICpcbiAqIGlzU3RyaW5nKDEpXG4gKiAvLyA9PiBmYWxzZVxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4gaXNTdHJpbmcoeCkgfHwgaXNOdW1iZXIoeClcbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxRQUFRLEdBQUcsT0FBTyxDQUFDLFVBQVUsQ0FBQztBQUNwQ0EsR0FBSyxDQUFDLFFBQVEsR0FBRyxPQUFPLENBQUMsVUFBVSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBc0JwQyxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLFFBQVEsQ0FBQyxDQUFDLENBQUMsSUFBSSxRQUFRLENBQUMsQ0FBQyxDQUFDLEdBQUE7In0=